import { Layout, ImportGrid } from '@/views/import_profile';

export default {
    path: '/import',
    component: Layout,
    children: [
        { path: 'grid', component: ImportGrid },
    ]
};
